import { render, staticRenderFns } from "./viewReturn.vue?vue&type=template&id=da6fcd44&"
import script from "./viewReturn.vue?vue&type=script&lang=js&"
export * from "./viewReturn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports